import Axios from 'axios'
import { SERVER_BASE_URL } from './baseUrl'

export const getInfoUser = async (token: string) => {
  try {
    const response = await Axios.get(`${SERVER_BASE_URL}api/users/user-info`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}

export const updateAccount = async (token: string, data: object) => {
  try {
    const updateUser = await Axios.put(`${SERVER_BASE_URL}api/users/update-account`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return updateUser.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}

export const deleteVisiteur = async (token: string, data: object) => {
  try {
    const updateUser = await Axios.put(`${SERVER_BASE_URL}api/users/update-account`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return updateUser.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}
